import { object, string, number } from 'yup';

export const enderecoSchema = object({
  id: string(),
  endereco: string().required('O logradouro é obrigatório'),
  numero: number().required('O número é obrigatório').positive().integer(),
  complemento: string().notRequired(),
  bairro: string().required('O bairro é obrigatório'),
  cidade: string().required('A cidade é obrigatória'),
  estado: string().required('O estado é obrigatório'),
  cep: string().required('O CEP é obrigatório'),
});

export class EnderecoModel {
  id = '';

  endereco = '';

  numero = 0;

  complemento = '';

  bairro = '';

  cidade = '';

  estado = '';

  cep = '';
}
